import { RouteProps } from 'react-router-dom';
import CustomRoutes from '@this/impl/routes/header.routes';
import { demoPagesMenu, pageLayoutTypesPagesMenu } from '../menu';

const headers: RouteProps[] = [
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path, element: null },
	{ path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path, element: null },
	{ path: pageLayoutTypesPagesMenu.blank.path, element: null },
	{ path: '/login', element: null },
	{ path: '/login/*', element: null },
	{ path: '/signup', element: null },
	{ path: demoPagesMenu.page404.path, element: null },
	...CustomRoutes,
];

export default headers;
